export type SeverityLevelFilter = "High" | "Medium" | "Low";

export type RiskyEventReportConfig = {
  severities: SeverityLevelFilter[];
  schedulePeriod: string; // "hh:mm:ss"
  scheduledAt: string; //"0001-01-01T00:00:00";
  lastExecutedAt: string; //"0001-01-01T00:00:00";
  isActive: boolean;
  recipients: string[];
  periodType: number;
  scheduledDayOfWeek: number; // 1 - sunday ...
};

export const DEFAULT_RISKY_EVENT_REPORT_CONFIG: RiskyEventReportConfig = {
  severities: ["High", "Medium", "Low"],
  schedulePeriod: "00:00:00",
  scheduledAt: "0001-01-01T00:00:00",
  lastExecutedAt: "0001-01-01T00:00:00",
  isActive: false,
  recipients: [],
  periodType: 0,
  scheduledDayOfWeek: 0,
};
